<template>
  <div
    v-if="!isModalLoading"
    class="content"
  >
    <div class="modal is-active">
      <div class="modal-background" />
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-marginless is-size-4">
            {{ userProfile.firstName }} {{ userProfile.lastName }}'s Statements by Year (#{{ $store.state.user.tempId }})
          </p>
          <button
            id="modal-close-btn"
            type="button"
            class="delete"
            aria-label="close"
            @click.prevent="$emit('close')"
          />
        </header>
        <section
          class="modal-card-body"
        >
          <div class="columns is-multiline">
            <div class="column is-12  has-text-centered">
              <div class="select">
                <select
                  v-model="filingYear"
                  class="select-year"
                >
                  <option value="">
                    Select Filing Year
                  </option>
                  <option
                    v-for="year in allFilingYears"
                    :key="year"
                    :value="year"
                  >
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="column is-12">
              <div v-if="filingYear !== ''">
                <div v-if="filingsByYear.length > 0">
                  <table class="file-now-table table is-bordered is-striped is-fullwidth table-content-center">
                    <thead>
                      <tr>
                        <th rowspan="2">
                          Year
                          <p class="is-size-4">
                            ID
                          </p>
                        </th>
                        <th colspan="3">
                          Required Forms
                        </th>
                        <th rowspan="2">
                          Status
                        </th>
                        <th rowspan="2">
                          Type
                        </th>
                        <th rowspan="2">
                          Date
                        </th>
                        <th rowspan="2">
                          Action
                        </th>
                      </tr>
                      <tr>
                        <th>City</th>
                        <th>State</th>
                        <th>Mayor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="filing in filingsByYear"
                        :key="filing.id"
                      >
                        <td>
                          {{ filingYear }}
                          <router-link
                            class="is-small"
                            target="_blank"
                            :to="{
                              name: 'filing-data',
                              params: {
                                filingId: filing.id,
                                userId: $store.state.user.tempId,
                              }
                            }"
                          >
                            #{{ filing.id }}
                          </router-link>
                        </td>
                        <td>
                          <template v-if="filing.cityForm === 'Y'">
                            <div v-if="filing.filingStatus === 'FI' || filing.filingStatus === 'AF'">
                              <template v-if="filing.filedOffline !== 'Y'">
                                <template v-if="filing.cityPdfUrl">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.cityPdfUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    :ref="`City_${filing.id}`"
                                    class="button is-small is-secondary"
                                    href="#"
                                    target="_blank"
                                    @click.prevent="genPdfUrl('City', filing.id)"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="filing.cityUrl !== null">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.cityUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <button
                                    id="modal-no-paper-filing-btn"
                                    type="button"
                                    class="button is-small is-warning"
                                    @click="noPaperFilingModal()"
                                  >
                                    <span>No PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-times" />
                                    </span>
                                  </button>
                                </template>
                              </template>
                              <template v-if="filing.cityRedactedUrl !== null">
                                <a
                                  class="button is-small is-secondary"
                                  :href="filing.cityRedactedUrl"
                                  target="_blank"
                                >
                                  <span>View Redaction</span>
                                  <span class="icon">
                                    <i class="is-small fad fa-file-pdf" />
                                  </span>
                                </a>
                              </template>
                            </div>
                            <div v-else-if="(filing.filingStatus === 'NF' || filing.filingStatus === 'AP') && filing.filedOffline !== 'Y'">
                              <a
                                :ref="`City-${filing.id}`"
                                class="button is-small is-warning"
                                href="#"
                                target="_blank"
                                @click.prevent="generatePdfPreview('City', filing.id)"
                              >
                                <span>View Draft PDF</span>
                                <span class="icon">
                                  <i class="is-small fad fa-file-pdf" />
                                </span>
                              </a>
                            </div>
                            <template v-else>
                              <div class="icon has-text-phanatic-green">
                                <i class="fad fa-check" />
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.stateForm === 'Y'">
                            <div v-if="filing.filingStatus === 'FI' || filing.filingStatus === 'AF'">
                              <template v-if="filing.filedOffline !== 'Y'">
                                <template v-if="filing.statePdfUrl">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.statePdfUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    :ref="`State_${filing.id}`"
                                    class="button is-small is-secondary"
                                    href="#"
                                    target="_blank"
                                    @click.prevent="genPdfUrl('State', filing.id)"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="filing.stateUrl !== null">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.stateUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <button
                                    id="modal-no-paper-filing-btn"
                                    type="button"
                                    class="button is-small is-warning"
                                    @click="noPaperFilingModal()"
                                  >
                                    <span>No PDF</span>
                                    <span class="icon is-small">
                                      <i class="is-small fad fa-file-times" />
                                    </span>
                                  </button>
                                </template>
                              </template>
                              <template v-if="filing.stateRedactedUrl !== null">
                                <a
                                  class="button is-small is-secondary"
                                  :href="filing.stateRedactedUrl"
                                  target="_blank"
                                >
                                  <span>View Redaction</span>
                                  <span class="icon">
                                    <i class="is-small fad fa-file-pdf" />
                                  </span>
                                </a>
                              </template>
                            </div>
                            <div v-else-if="(filing.filingStatus === 'NF' || filing.filingStatus === 'AP') && filing.filedOffline !== 'Y'">
                              <a
                                :ref="`State-${filing.id}`"
                                class="button is-small is-warning"
                                href="#"
                                target="_blank"
                                @click.prevent="generatePdfPreview('State', filing.id)"
                              >
                                <span>View Draft PDF</span>
                                <span class="icon">
                                  <i class="is-small fad fa-file-pdf" />
                                </span>
                              </a>
                            </div>
                            <template v-else>
                              <div class="icon has-text-phanatic-green">
                                <i class="fad fa-check" />
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.mayorForm === 'Y'">
                            <div v-if="filing.filingStatus === 'FI' || filing.filingStatus === 'AF'">
                              <template v-if="filing.filedOffline !== 'Y'">
                                <template v-if="filing.mayorPdfUrl">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.mayorPdfUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    :ref="`Mayor_${filing.id}`"
                                    class="button is-small is-secondary"
                                    href="#"
                                    target="_blank"
                                    @click.prevent="genPdfUrl('Mayor', filing.id)"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="filing.mayorUrl !== null">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.mayorUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <button
                                    id="modal-no-paper-filing-btn"
                                    type="button"
                                    class="button is-small is-warning"
                                    @click="noPaperFilingModal()"
                                  >
                                    <span>No PDF</span>
                                    <span class="icon is-small">
                                      <i class="is-small fad fa-file-times" />
                                    </span>
                                  </button>
                                </template>
                              </template>
                              <template v-if="filing.mayorRedactedUrl !== null">
                                <a
                                  class="button is-small is-secondary"
                                  :href="filing.mayorRedactedUrl"
                                  target="_blank"
                                >
                                  <span>View Redaction</span>
                                  <span class="icon">
                                    <i class="is-small fad fa-file-pdf" />
                                  </span>
                                </a>
                              </template>
                            </div>
                            <div v-else-if="(filing.filingStatus === 'NF' || filing.filingStatus === 'AP') && filing.filedOffline !== 'Y'">
                              <a
                                :ref="`Mayor-${filing.id}`"
                                class="button is-small is-warning"
                                href="#"
                                target="_blank"
                                @click.prevent="generatePdfPreview('Mayor', filing.id)"
                              >
                                <span>View Draft PDF</span>
                                <span class="icon">
                                  <i class="is-small fad fa-file-pdf" />
                                </span>
                              </a>
                            </div>
                            <template v-else>
                              <div class="icon has-text-phanatic-green">
                                <i class="fad fa-check" />
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.filedOffline !== 'Y'">
                            {{ filingStatusLabel(filing.filingStatus) }}
                            <template v-if="filing.filingStatus !== 'AP' && filing.filingStatus !== 'NF'">
                              {{ filing.amendmentSeq | hasAmendmentSeq }}
                            </template>
                          </template>
                          <template v-else>
                            <div v-if="filing.cityForm === 'Y'">
                              <template v-if="filing.filedOffline === 'Y' && filing.cityReceived === ''">
                                <strong>City:</strong> N/A
                              </template>
                              <template v-else>
                                <strong>City:</strong> {{ filing.cityReceived === 'Y' ? 'Received' : 'Pending' }}
                              </template>
                            </div>
                            <div v-if="filing.stateForm === 'Y'">
                              <template v-if="filing.filedOffline === 'Y' && filing.stateReceived === ''">
                                <strong>State:</strong> N/A
                              </template>
                              <template v-else>
                                <strong>State:</strong> {{ filing.stateReceived === 'Y' ? 'Received' : 'Pending' }}
                              </template>
                            </div>
                            <div v-if="filing.mayorForm === 'Y'">
                              <template v-if="filing.filedOffline === 'Y' && filing.mayorReceived === ''">
                                <strong>Mayor:</strong> N/A
                              </template>
                              <template v-else>
                                <strong>Mayor:</strong> {{ filing.mayorReceived === 'Y' ? 'Received' : 'Pending' }}
                              </template>
                            </div>
                          </template>
                        </td>
                        <td>
                          {{ filing.filedOffline === 'Y' ? 'Paper Filing' : 'Online Filing' }}
                        </td>
                        <td>
                          <template v-if="filing.filingStatus === 'NF' || filing.filingStatus === 'AP'">
                            Started on <br> {{ formatDate(filing.createdOn) }}
                          </template>
                          <template v-if="filing.filingStatus === 'FI'">
                            {{ filing.completedDate !== '0001-01-01T00:00:00' ? `Completed on ${formatDate(filing.completedDate)}` : 'Not available' }}
                          </template>
                          <template v-if="filing.filingStatus === 'AF'">
                            {{ filing.completedDate !== '0001-01-01T00:00:00' ? `Amended on ${formatDate(filing.completedDate)}` : 'Not available' }}
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.amendable === 'Y'">
                            <template v-if="filing.filingStatus === 'AP' || filing.filingStatus === 'NF'">
                              <button
                                id="update-flag-btn-1"
                                type="button"
                                class="button is-secondary is-small"
                                @click="filingRequirementsModal(filing)"
                              >
                                Update Requirements
                              </button>
                              <button
                                id="modal-delete-btn"
                                type="button"
                                class="button is-danger is-small"
                                @click="deleteDraftModal(filing.id)"
                              >
                                <span>Delete Draft</span>
                                <span class="icon is-small">
                                  <i class="fas fa-trash" />
                                </span>
                              </button>
                            </template>
                            <template v-else>
                              <button
                                id="modal-upload-amendment-btn"
                                type="button"
                                class="button is-small is-secondary"
                                @click="uploadPaperFilingModal('AF', filing)"
                              >
                                <span>Upload Amendment</span>
                                <span class="icon is-small">
                                  <i class="fas fa-file-upload" />
                                </span>
                              </button>
                              <button
                                v-if="adminProfile.canRedact === 'Y'"
                                class="button is-small is-warning"
                                @click="redactionModal(filing.id, filing.year, filingStatusLabel(filing.filingStatus))"
                              >
                                <span>Redactions</span>
                                <span class="icon is-small">
                                  <i class="fad fa-eraser" />
                                </span>
                              </button>
                            </template>
                          </template>
                          <template v-if="filing.amendable !== 'Y'">
                            <template v-if="filing.filingStatus === 'NF' || filing.filingStatus === 'AP'">
                              <button
                                id="update-flag-btn-2"
                                type="button"
                                class="button is-secondary is-small"
                                @click="filingRequirementsModal(filing)"
                              >
                                Update Requirements
                              </button>
                              <button
                                id="modal-delete-btn-2"
                                type="button"
                                class="button is-danger is-small"
                                @click="deleteDraftModal(filing.id)"
                              >
                                <span>Delete Draft</span>
                                <span class="icon is-small">
                                  <i class="fas fa-trash" />
                                </span>
                              </button>
                            </template>
                            <template v-else>
                              <button
                                v-if="adminProfile.canRedact === 'Y'"
                                class="button is-small is-warning"
                                @click="redactionModal(filing.id, filing.year, filingStatusLabel(filing.filingStatus))"
                              >
                                <span>Redactions</span>
                                <span class="icon is-small">
                                  <i class="fad fa-eraser" />
                                </span>
                              </button>
                            </template>
                          </template>
                          <template v-if="filing.filedOffline === 'Y' && (!filing.cityUrl || !filing.stateUrl || !filing.mayorUrl)">
                            <button
                              v-if="!paperFiling"
                              id="modal-upload-filing-btn"
                              type="button"
                              title="Upload Paper Filing"
                              class="button is-primary is-small"
                              @click="uploadHistoricalPaperFilingModal(filing)"
                            >
                              <span>Upload Missing PDF</span>
                              <span class="icon is-small">
                                <i class="fas fa-file-upload" />
                              </span>
                            </button>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-if="filingsByYear.length === 0"
                >
                  <table class="file-now-table table is-bordered is-striped is-fullwidth table-content-center">
                    <thead>
                      <tr>
                        <th rowspan="2">
                          Year
                        </th>
                        <th colspan="3">
                          Required Forms
                        </th>
                        <th rowspan="2">
                          Due Date
                        </th>
                        <th rowspan="2">
                          Action
                        </th>
                      </tr>
                      <tr>
                        <th>City</th>
                        <th>State</th>
                        <th>Mayor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ filingYear }}
                        </td>
                        <td>
                          <template v-if="userProfile.cityForm === 'Y'">
                            <div class="icon has-text-phanatic-green">
                              <i class="fad fa-check" />
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="userProfile.stateForm === 'Y'">
                            <div class="icon has-text-phanatic-green">
                              <i class="fad fa-check" />
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="userProfile.mayorForm === 'Y'">
                            <div class="icon has-text-phanatic-green">
                              <i class="fad fa-check" />
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          {{ filingsDueDate ? filingsDueDate.description : 'No due date set' }}
                        </td>
                        <td>
                          <button
                            v-if="!paperFiling"
                            id="modal-upload-filing-btn"
                            type="button"
                            title="Upload Paper Filing"
                            class="button is-primary is-small"
                            @click="uploadPaperFilingModal('NF', { year: filingYear })"
                          >
                            <span>Upload Filing</span>
                            <span class="icon is-small">
                              <i class="fas fa-file-upload" />
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="columns">
      <div class="column">
        <loading
          :loading="isModalLoading"
          :center="true"
          width="60px"
          message=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { pdfData } from '@/mixins/pdfData';
import UploadStatements from '@/modals/UploadStatements';
import UploadHistoricalStatements from '@/modals/UploadHistoricalStatements';
import UpdateRequirements from '@/modals/UpdateRequirements';
import Redactions from '@/modals/Redactions';
import NoPaperFiling from '@/modals/NoPaperFiling';
import DeleteDraft from '@/modals/DeleteDraft';

export default {
  name: 'UserStatements',
  components: {},
  filters: {
    hasAmendmentSeq (amendmentSeq) {
      if (parseInt(amendmentSeq) > 0) {
        return amendmentSeq;
      }
      return '';
    },
  },
  mixins: [
    filerScreenHelpers,
    pdfData,
  ],
  props: {
    selectedYear: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isModalLoading: true,
      filingYear: '',
      paperFiling: false,
      copyFrom: null,
    };
  },
  computed: {
    formFullNames () {
      return this.$store.state.formFullNames;
    },
    formNumbers () {
      return this.$store.state.formNumbers;
    },
    adminProfile () {
      return this.$store.state.user.profile;
    },
    userProfile () {
      return this.$store.state.user.tempProfile;
    },
    currentYear () {
      return parseInt(this.$store.state.admin.controlValues.currentyear.slice(0, 1)[ 0 ].description);
    },
    filingYears () {
      return this.$store.getters[ 'admin/activeControlValues' ]('filingyears');
    },
    filingsDueDate () {
      if (this.filingYear !== '') {
        return this.$store.getters[ 'admin/filingsDueDate' ](this.filingYear);
      }
      return [];
    },
    filingsByYear () {
      if (this.filingYear !== '') {
        return this.$store.getters[ 'filings/filingsByYear' ](this.filingYear);
      }
      return [];
    },

    /**
    * @desc merges user filing years with admin filing years range
    * @returns { Array } of years
    */
    allFilingYears () {
      let userFiledYears = this.$store.getters[ 'filings/userFiledYears' ];
      if (this.filingYears.length > 0) {
        this.filingYears.forEach(filingYear => {
          if (!userFiledYears.includes(parseInt(filingYear.description))) {
            userFiledYears.push(parseInt(filingYear.description));
          }
        });
      }

      return userFiledYears.sort((a, b) => b - a);
    },
  },
  async mounted () {
    Object.assign(this.$data, this.$options.data());
    await this.initialFetch();
    await this.initialAssign();
    this.isModalLoading = false;
  },
  methods: {
    async genPdfUrl (type, filingId) {
      let el = this.$refs[`${type}_${filingId}`][0];
      el.text = 'loading...';
      let pdfData = await this.pdf_getPdfData(type, filingId);
      let pdfUrl = await this.$store.dispatch('filing/getAdminPdf', pdfData);
      el.text = 'View PDF';
      window.open(pdfUrl, "_blank");
    },
    async initialAssign () {
      if (this.selectedYear !== '') {
        this.filingYear = this.selectedYear;
      } else {
        this.filingYear = this.currentYear;
      }
    },
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('admin/getControlValue', 'currentyear'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'filingyears'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'filingduedate'));
      promises.push(this.$store.dispatch('user/fetchUserProfile', this.$store.state.user.tempId));
      promises.push(this.$store.dispatch('filings/fetchUserFilings', this.$store.state.user.tempId));
      await Promise.all(promises);
    },
    filingStatusLabel (status) {
      return this.$store.state.filings.filingsMap[ status ];
    },
    updateFilingProfile (filingId, filingProfile) {
      this.$store.dispatch('filing/saveFiling', {
        filingId,
        filingProfile,
      });
    },
    deleteDraftModal (filingId) {
      this.$modal.show(DeleteDraft, {
        filingId,
        userType: 'temp',
      }, {
        classes: [ 'is-small' ],
      });
    },
    noPaperFilingModal () {
      this.$modal.show(NoPaperFiling, {}, {
        classes: [ 'is-small' ],
      });
    },
    uploadPaperFilingModal (type, filing) {
      this.$modal.show(UploadStatements, {
        type,
        filing,
        profile: this.userProfile,
      }, {
        classes: [ 'is-medium' ],
      });
    },
    uploadHistoricalPaperFilingModal (filing) {
      this.$modal.show(UploadHistoricalStatements, {
        filing,
      }, {
        classes: [ 'is-medium' ],
      });
    },
    redactionModal (filingId, year, filingStatus) {
      this.$modal.show(Redactions, {
        filingId,
        year,
        filingStatus,
      }, {
        classes: [ 'is-medium' ],
      });
    },
    filingRequirementsModal (filing) {
      this.$modal.show(UpdateRequirements, {
        filing,
      }, {
        classes: [ 'is-medium' ],
      });
    },
    async generatePdfPreview(type, filingId) {

      this.$refs[`${type}-${filingId}`][0].classList.add("is-loading");
      let formData = await this.pdf_getPdfData(type, filingId, true);
      let pdfUrl = await this.$store.dispatch('filing/getPdf', formData);

      if (pdfUrl) {
        window.open(pdfUrl);
      } else {
        this.$warning("There was an issue retrieving the pdf preview");
      }

      this.$refs[`${type}-${filingId}`][0].classList.remove("is-loading");

    },
  },
};

</script>

<style scoped lang="scss">
  table.file-now-table {
    th, td {
      &:nth-child(1) {
        width: 5%;
      }
      &:nth-child(2), &:nth-child(3), &:nth-child(4) {
        width: 10%;
      }
      &:nth-child(5) {
        width: 15%;
      }
      &:nth-child(6) {
        width: 15%;
      }
      &:nth-child(7) {
        width: 15%;
      }
      &:nth-child(8) {
        width: 40%;
      }
    }
    &.table-content-center {
      td, th {
        text-align: center;
        vertical-align: middle;
      }
    }
    .button {
      width: 100%;
      margin-bottom: 2px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  .select-year {
    display: block;
    max-width: 280px;
    margin: 0 auto !important;
  }
  .popup-paper-filing {
    p {
      color: red;
      font-size: 16px;
    }
  }
</style>
